/// <amd-module name="Environments/EnvironmentsCommon/DateUtils" />

/**
    * Compares two date objects. Returns a number:
    *    Less than 0 if date1 is earlier than date2
    *    Zero if date1 is the same as date2
    *    Greater than zero if date1 is later than date2
    *
    * If an argument is not an instance of a Date then it is considered earlier than
    * the other argument, or the same if the other argument is also not an instance of 
    * a Date
    * 
    * @param date1 Date object to compare
    * @param date2 Date object to compare
    * @return 
    */
export function defaultComparer(date1: Date | undefined, date2: Date | undefined): number {

    if (date1 instanceof Date && date2 instanceof Date) {
        return date1.getTime() - date2.getTime();
    }

    if (date1 instanceof Date) {
        return 1;
    }

    if (date2 instanceof Date) {
        return -1;
    }

    // Both date objects are not dates: consider them equal
    return 0;
}